<form [formGroup]="providerForm" (ngSubmit)="onSubmit(isUpdateForm)">
<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">{{dialogTitle}}</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
</div>
<div [ngStyle]="{'max-height': maxHeight, 'width': '100%', 'overflow': 'auto'}" class="modal-body text-grey">
    <div style="width: 100%" *ngIf="!isUpdateForm">
      <div style="width: inherit; margin-bottom: 15px; border-bottom: solid 1px; border-color: var(--bs-border-color); padding: 2%" *ngFor="let field of provider.fields">
        <div style="display: flex; align-items: center; justify-content: center">
          <label style="width: 30%; font-size: 1.1em" [for]="field.name">{{ field.name | titlecase }}</label>

          <textarea *ngIf="field.name == 'Service Account JSON Key'" style="width: 70%; height: 2.1em" rows=4 class="form-control" [formControlName]="field.name" [id]="field.name"></textarea>
          <input *ngIf="field.name != 'Service Account JSON Key'" style="width: 70%; height: 2.1em" class="form-control" [type]="field.type" [formControlName]="field.name" [id]="field.name">
        </div>
        <div *ngIf="providerForm?.get(field.name).errors?.required && providerForm?.get(field.name).touched"
             class="error-message">
          This field is required.
        </div>
      </div>
    </div>
    <div style="width: 100%" *ngIf="isUpdateForm">
      <div style="width: inherit; margin-bottom: .2rem; padding: 2% " *ngFor="let field of updateProvider.fields">
        <div style="display: flex; align-items: center; justify-content: center">
          <label style="width: 30%; font-size: 1.1em" class="form-label m-1" [for]="field.name">{{ field.name | titlecase }}</label>
          <textarea *ngIf="field.name == 'Service Account JSON Key'" style="width: 70%; height: 2.1em; font-size: 1.1em;" class="form-control" rows=4 [formControlName]="field.name" [id]="field.name"></textarea>
          <input *ngIf="field.name != 'Service Account JSON Key'" style="width:70%; height:2.1em; font-size: 1.1em" class="form-control" [type]="field.type" [formControlName]="field.name" [id]="field.name">
        </div>
        <div *ngIf="providerForm?.get(field.name).errors?.required && providerForm?.get(field.name).touched"
              class="error-message">
          This field is required.
        </div>
      </div>
    </div>
  </div> <!--! Modal Body ends here-->
  <div class="modal-footer" style="width:100%; display:flex; align-items:center; justify-content:end">
    <div style="width:30%; display:flex; align-items:center; justify-content:space-between">
      <button class="btn btn-outline-secondary" (click)="onClose()">Cancel</button>
      <button class="btn btn-primary" [disabled]="!providerForm?.valid" type="submit">Submit</button>
    </div>
  </div>
  <ngx-spinner
    bdColor="rgba(236,236,236,0.8)"
    size="default" zIndex = "1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="true"
    name="addNewCredential">
  </ngx-spinner>
</form>

